import { LayoutProvidedTaskDecoratorProps } from "@mcleod/components";
import { AutogenLayoutManualOfficePostingReport } from "./autogen/AutogenLayoutManualOfficePostingReport";

const TASK_DESCRIPTION = "Manual Office Payroll Posting";

export class ManualOfficePostingReport extends AutogenLayoutManualOfficePostingReport {
    public override get taskDecoratorProps(): Partial<LayoutProvidedTaskDecoratorProps> {
        return {
            processLogDescription: TASK_DESCRIPTION,
            executeButtonCaption: "Post"
        };
    }
}
